export default __webpack_public_path__ + "static/media/a10.4e192e9e.png";